import {
	type JSONValue,
	type CrossFlowExtensionsOptions,
	CrossFlowExtensions,
} from '@atlassiansox/cross-flow-base-types';

export const filterProperties = (
	object: Record<string, JSONValue | undefined>,
	propertyNames: string[],
): Record<string, JSONValue> =>
	propertyNames.reduce(
		(accumulator, property) => {
			const value = object[property];
			if (value !== undefined) {
				accumulator[property] = value;
			}
			return accumulator;
		},
		{} as Record<string, JSONValue>,
	);

export const createProductExtensions =
	<T extends Record<string, JSONValue | undefined>>(extensionsWhitelist: string[]) =>
	(options: T): CrossFlowExtensions => {
		const filteredOptions = filterProperties(options, extensionsWhitelist);
		return new CrossFlowExtensions(filteredOptions);
	};

export const combineExtensions = (...extensions: CrossFlowExtensions[]): CrossFlowExtensions => {
	const combinedOptions: CrossFlowExtensionsOptions = Object.assign({}, ...extensions);
	return new CrossFlowExtensions(combinedOptions);
};
